import { z } from 'zod';
import { ERROR_CODES } from './result.js';
/**
 * The single error envelope every API error uses, per TechSpec §4.2.
 * Internal detail MUST NOT be placed in `message` or `details` in production —
 * it belongs in the log line carrying the same correlation id.
 */
export const ErrorEnvelopeSchema = z.object({
    error: z.object({
        code: z.enum(ERROR_CODES),
        message: z.string(),
        details: z.unknown().optional(),
        requestId: z.string().optional(),
    }),
});
//# sourceMappingURL=error-envelope.js.map